export const styles = theme => ({
    borderButton: {
		border: '1px solid #A0750E',
		backgroundColor: 'transparent',
		color: '#A0750E',
		boxShadow: 'none',
		minWidth: '160px',
		textAlign: 'right',
		fontSize: '18px',
		letterSpacing: '3.6px',
		padding: '8px 10px',
		marginRight: '15px',
		marginBottom: '15px',
		textTransform: 'none',
		borderRadius:'4px',
		'&:hover': {
			backgroundColor: '#A0750E',
			color: '#fff'
		}
	},
});
  